import React from "react";
// components
import MNPGV2 from "./MNPGV2";
import FooterBottomShape01 from "@/components/shapes/FooterBottomShape01";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG006 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG006.rendered", props);

    if ( !props.template ) return null;

    return (
        <div className="footer-bottom">
            <FooterBottomShape01 />
            <div className="container">
                <div className="footer-wrapper d-flex align-items-center justify-content-between">
                    <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />
                </div>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG006, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG006.memo", { prevProps, nextProps });
    return true;
});

export default Component;
